module.exports = __webpack_public_path__ + "static/logo@3x-05f65e5766e062543ffe9f813a16a744.png";